import { Injectable } from '@angular/core';

import { SystemKey } from '../../../../lib/system-bets/system-key.enum';
import { SlipTypeKeys } from '../../bet-generation/betslip-system-type';
import { ComboSlipType, SingleSlipType, SlipType, SystemBankerSinglesSlipType, SystemSlipType } from '../../bet-generation/slip-type';
import { populateOrder } from '../../utils/bet-type.utils';
import { ISystemBetSavedState, ISystemBetState, ISystemBetTypeStake, defaultSystemBetState } from '../state';

@Injectable()
export default class SystemBetStateStorageService {
    toSavedState(state: ISystemBetState): ISystemBetSavedState {
        return {
            ...state,
            systemInfo: state.systemInfo && state.systemInfo.toJSON(),
        };
    }

    fromSavedState(state: ISystemBetSavedState): ISystemBetState {
        if (!state) {
            return defaultSystemBetState;
        }

        return {
            ...state,
            picks: populateOrder(state.picks),
            systemInfo: state.systemInfo && createSlipType(state.systemInfo),
            linearTypeStakes: state.linearTypeStakes && createLinearTypeStakes(state.linearTypeStakes),
        };
    }
}

function createSlipType(input: { key: string; name: string; basis: number[] }): SlipType {
    switch (input.key) {
        case SlipTypeKeys.Single: {
            return new SingleSlipType();
        }
        case SlipTypeKeys.Combo: {
            return new ComboSlipType();
        }
        case SystemKey.BankerSingles: {
            return new SystemBankerSinglesSlipType();
        }
        default: {
            return new SystemSlipType(input.key, input.name, input.basis);
        }
    }
}

function createLinearTypeStakes(input: Record<string, ISystemBetTypeStake>): Record<string, ISystemBetTypeStake> {
    return Object.entries(input).reduce(
        (acc, [key, value]) => {
            acc[key] = {
                ...value,
                slipType: createSlipType(value.slipType),
            };

            return acc;
        },
        {} as Record<string, ISystemBetTypeStake>,
    );
}
